import { Investment } from "./types";
import { StoreState } from "../types";

export const saveSharesInfoReducer = (
  state: StoreState,
  currentShare: Investment
) => {
  localStorage.setItem("currentShare", JSON.stringify(currentShare));

  return {
    ...state,
    currentShare,
  };
};
